export default __webpack_public_path__ + "static/media/wmlApp2.41da5346.jpg";